import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatbotConfig, ChatbotState } from 'constants/chat.constants';

import { RootState } from '../store';
import { ThunkAction, Action } from '@reduxjs/toolkit';

// Define the AppThunk type
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

const initialState: ChatbotState = {
	config: null,
	isLoading: false,
	error: null,
	scriptLoaded: false,
};

export const chatbotSlice = createSlice({
	name: 'chatbot',
	initialState,
	reducers: {
		setScriptLoaded: (state, action: PayloadAction<boolean>) => {
			state.scriptLoaded = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setChatConfig: (state, action: PayloadAction<ChatbotConfig>) => {
			state.config = action.payload;
			state.error = null;
		},
		setChatError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
	},
});

export const { setScriptLoaded, setLoading, setChatConfig, setChatError } = chatbotSlice.actions;

export default chatbotSlice.reducer;
